'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _find3 = require('lodash/find');

var _find4 = _interopRequireDefault(_find3);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reduxConnect = require('redux-connect');

var _reactRedux = require('react-redux');

var _components = require('components');

var _quicksend = require('redux/modules/quicksend');

var quickSendActions = _interopRequireWildcard(_quicksend);

var _quicksend2 = require('selectors/quicksend');

var _reactRouterRedux = require('react-router-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./QuickSends.scss');

var QuickSends = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        type = _ref.params.type;

    if (!quickSendActions.isLoaded(type, getState())) {
      return (0, _asyncPromise2.default)(dispatch(quickSendActions.loadBox(type)).promise);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    boxType: ownProps.params.type,
    boxView: state.quicksend.boxView,
    loadedBoxType: state.quicksend.loadedBoxType,
    qsId: Number(ownProps.params.qsId),
    qsList: (0, _quicksend2.processQuickSends)(state),
    qsListLoading: state.quicksend.qsListLoading
  };
}, (0, _extends3.default)({}, quickSendActions, { pushState: _reactRouterRedux.push })), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSends, _Component);

  function QuickSends() {
    (0, _classCallCheck3.default)(this, QuickSends);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSends.__proto__ || (0, _getPrototypeOf2.default)(QuickSends)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSends, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.toggleBoxView('box');
    }
  }, {
    key: 'onDelete',
    value: function onDelete() {
      var _props = this.props,
          pushState = _props.pushState,
          boxType = _props.boxType;

      pushState('/quick-send/' + boxType);
    }
  }, {
    key: 'onRefresh',
    value: function onRefresh() {
      var _props2 = this.props,
          pushState = _props2.pushState,
          boxType = _props2.boxType,
          qsList = _props2.qsList,
          qsId = _props2.qsId;

      if (!(0, _find4.default)(qsList, { projectId: qsId })) {
        pushState('/quick-send/' + boxType);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          mainChild = _props3.mainChild,
          boxType = _props3.boxType,
          qsListLoading = _props3.qsListLoading,
          qsList = _props3.qsList,
          qsId = _props3.qsId,
          boxView = _props3.boxView,
          loadedBoxType = _props3.loadedBoxType;

      var isBoxLoaded = loadedBoxType === boxType;
      var isLoading = qsListLoading || !isBoxLoaded;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, { title: 'Quick Send' }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('container-fluid', styles.container, (0, _defineProperty3.default)({}, styles.showItem, boxView === 'item')) },
          _react2.default.createElement(
            'div',
            { className: styles.boxSection },
            _react2.default.createElement(_components.QuickSendBoxTabs, { active: boxType }),
            _react2.default.createElement(
              'div',
              { className: styles.boxContainer },
              isBoxLoaded && _react2.default.createElement(_components.QuickSendList, {
                items: qsList,
                activeId: qsId,
                boxType: boxType
              }),
              isLoading && _react2.default.createElement(_components.Loader, { mask: true })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.viewSection },
            _react2.default.createElement(_components.QuickSendActions, {
              boxType: boxType,
              qsId: qsId,
              onDelete: this.onDelete,
              onRefresh: this.onRefresh
            }),
            mainChild
          )
        )
      );
    }
  }]);
  return QuickSends;
}(_react.Component), _class3.propTypes = {
  boxType: _propTypes2.default.string,
  boxView: _propTypes2.default.string,
  loadedBoxType: _propTypes2.default.string,
  mainChild: _propTypes2.default.object.isRequired,
  pushState: _propTypes2.default.func,
  qsId: _propTypes2.default.number,
  qsList: _propTypes2.default.array,
  qsListLoading: _propTypes2.default.bool,
  toggleBoxView: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRefresh', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRefresh'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = QuickSends;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/QuickSend/QuickSends/QuickSends.js
// module id = 2208
// module chunks = 1